interface SocialQuoteMetaData {
  quote: string;
  quoteSource: string;
  quoteCreated: string;
  quotePerson: string;
  quotePersonHandle: string;
  quotePersonImageUrl: string;
  gallery: { imageUrl: string }[];
}

export const getSocialQuoteMetaData = async (url: string): Promise<SocialQuoteMetaData> => {
  const response = await fetch('https://n8n.tchop.live/webhook/apple-podcast-meta', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  });

  return await response.json();
};
